export const ProTipStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      py: 10,
      justifyContent: 'space-between',
      alignItems: 'center',
      // Styling for Bullet Bank Modals
      modalContent: {
        padding: '36px 80px',
        margin: '260px',
        minHeight: '360px',
        minWidth: '700px',
      },
      modalCloseButton: {
        margin: '56px 36px 0 0',
        fontSize: '26px',

      },
      modalFooter: {
        justifyContent: 'right',
      },
    },
  },
};
